// Mirrors FA_OVERRIDE_EMAILS in utils/faProofCheck.js (server). These people can "Send anyway" on
// a failed FA screenshot check and remove a candidate blacklist. The server enforces both; this
// copy only decides what the UI offers, so keep the two lists in sync.
export const OVERRIDE_EMAILS = [
  'gv@mountainrecruiting.com',
  'ajroy@mountainrecruiting.com',
  'monica@mountainrecruiting.com',
  'atiya@mountainrecruiting.com',
  'madhu@mountainrecruiting.com',
];

export const canOverride = user =>
  user?.role === 'admin' || OVERRIDE_EMAILS.includes(String(user?.email || '').toLowerCase());

// Who sees the Call / Text buttons on a candidate (October 2026): admins (AJ, Monica) and GV on
// every candidate, everyone else only on their own. Mirrors canContactAnyCandidate in
// routes/sms-inbox.js, which enforces the texting side.
export const CONTACT_ANY_EMAILS = ['gv@mountainrecruiting.com', 'ajroy@mountainrecruiting.com', 'monica@mountainrecruiting.com'];
export const canContactCandidate = (user, candidate) =>
  String(user?.role || '').toLowerCase() === 'admin'
  || CONTACT_ANY_EMAILS.includes(String(user?.email || '').toLowerCase())
  || (candidate && candidate.recruiter_id === user?.id);
